<template lang="pug">
.form-check.dawn-radio(:class='{ inline: $parent.$attrs["inline"] !== undefined, disabled }')
  label.form-check-label
    input.form-check-input(type='radio' v-if='!$attrs["track-by"]'
      :name='name'
      :id='optionLabel'
      :value='optionValue'
      @input='$emit("input", optionValue)'
      @click="chooseRadio"
      ref="radio"
      :checked="optionValue === value"
      :disabled='disabled'
    )
    input.form-check-input(type='radio' v-else
      :name='name'
      :id='optionLabel'
      :value='optionValue'
      @click="chooseRadio"
      :checked='checked'
      :disabled='disabled'
    )
    span.radio-mask(:class="{ invalid: $attrs.error }")
    slot(name='icon')
    span.text(v-if='!$slots.default') {{ optionLabel }}
    .dawn-radio-option-content(v-else)
      slot
    .dawn-radio-option-content.additional(v-if='hasAdditionalInfo')
      slot(:name='slotName')
</template>

<script>

import { EventBus } from '@/event-bus.js'

export default {
  name: 'radio',

  props: {
    checked: Boolean,
    value: null,
    optionIndex: Number,
    optionLabel: String,
    optionValue: null,
    name: String,
    disabled: Boolean,
    hasAdditionalInfo: Boolean,
    slotName: String
  },

  computed: {
    _optionStatus: function() {
      return this.optionStatus
    },
    _optionLabel: function() {
      return this.optionName
    },
    _optionIndex: function() {
      return this.optionIndex
    }
  },

  methods: {
    chooseRadio: function() {
      EventBus.$emit('chooseRadio', {
        'idx': this._optionIndex,
        'status': !this._optionStatus
      })
      //
      this.$emit('choose-radio')
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

@mixin dawn-radio() {
  & {
    opacity: 0;
  }
  &, & + .radio-mask {
    position: relative;
    margin: 0 0.2rem 0 0;
    padding: 0;
    text-align: center;
    width: 1.06rem;
    height: 1.0304rem;
    background: white;
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    border-radius: 50%;
    color: rgba(white, 0);
    transition: all 0.2s ease;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    vertical-align: middle;

    &:before {
      font-family: 'Font Awesome 5 Solid';
      content: "\f111";
      font-size: 13px;
      width: 19px;
      // text-indent: -0.055em;
      //opacity: 0;
      position: absolute;
      left: -1px;
      right: 0;
      top: 2px;
      bottom: 0;
      line-height: .95em;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-style: normal !important;
    }
    &:focus {
      outline: 0;
    }
    &:active {
      outline: none;
    }
    &:hover {
      outline: none;
      cursor: pointer;
    }
    &:checked,
    &:checked + .radio-mask,
    &:checked + .radio-mask:before {
      @include theme { color: v(border) }
      &:before {
        opacity: 1;
      }
    }

    & + .radio-mask {
      border: $border-default;
      @include theme() {
      background-image: linear-gradient( darken(v(canvas), 2%), v(canvas) );
      border-color: v(border);
      }

      .invalid &, &.invalid {
        @include theme() {
        border-color: v(urgent-01);
        }
      }

      margin-top: -0.01rem;
      margin-left: -1.22rem;
      display: inline-block;
      &:before {
        //opacity: 0;
      }
    }
    &:focus + .radio-mask {
      @include theme() {
      border: $border-width-default solid v(tertiary-01);
      box-shadow: 0px 0px 0px 1px v(tertiary-01);
      }
    }

  }
}

.theme.skin .form-group .form-check-label,
.form-check-label {
  @include form-check-label;
  color: inherit;
}

.dawn-radio {
  .form-check-input {
    @include form-field;
    @include dawn-radio;
    display: inherit;
  }

  .radio-mask {
    min-width: 19px;
    min-height: 18px;
    line-height: 1;

    & + span.text.text.text {
      line-height: 2em;
      font-size: $font-size-base-sm;
      font-weight: $font-weight-normal;
    }
  }

  &.inline {
    display: inline;
    padding-right: 1em;
    z-index: 1;
    position: relative;
    background: inherit;
  }

  &-option-content {
    margin-top: -2px;
    padding-bottom: 10px;
    font-size: $font-size-medium;
    display: inline-block;
    vertical-align: top;
    margin-left: .5rem;
    width: calc(100% - 2rem);

    &.additional {
      margin-left: 2em;
    }

    p {
      line-height: 1.3;
    }

    a {
      text-decoration: underline;
    }

    .option-label {
      line-height: 2em;
      font-size: $font-size-base-sm;
      font-weight: $font-weight-normal;
    }
  }
  &.disabled {
    opacity: .5;
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edRadio/radio.vue